import type { UndecoratedFile } from '@witmetrics/utils';
import { getFileCategory } from '@witmetrics/utils/files';
import { FILE_CATEGORY_COLORS } from '@witmetrics/unison-core';
import Icon, { type IconProps } from '@/components/Icon';
import { ICONS } from './constants';

export interface FileCategoryIconProps extends Omit<IconProps, 'icon'> {
  file: Pick<UndecoratedFile, 'name' | 'fileTypeId'>;
}

export default function FileCategoryIcon({
  file,
  ...props
}: FileCategoryIconProps) {
  const category = getFileCategory(file);
  const colors = FILE_CATEGORY_COLORS[category];
  const CategoryIcon = ICONS[category];

  return (
    <Icon
      icon={<CategoryIcon />}
      color={colors.text}
      backgroundColor={colors.bg}
      borderColor={colors.border}
      {...props}
    />
  );
}
